module.exports = __webpack_public_path__ + "images/plp/self-storage.svg";